import { commonRoutes, externalRoutes } from '@/app/providers/router/routes';
import { DOCS_URL } from '@/app/shared/constants/common';

export const Footer = () => {
  return (
    <footer className='border-decoration-stroke flex items-stretch border-t'>
      <div className='bg-decoration-stroke border-decoration-stroke hidden w-6 border-r xl:block' />

      <div className='flex flex-1 flex-col items-start justify-center gap-6 p-6 lg:flex-row lg:items-center lg:justify-between'>
        <div className='flex gap-4'>
          <span className='text-gray-500'>{`© Mezzanine - ${new Date().getFullYear()}`}</span>
          <span className='text-gray-600'>v1.0</span>
        </div>

        <nav className='flex flex-wrap gap-x-6 gap-y-3 text-gray-500'>
          <a
            href={'https://testnet.snapshot.box/#/s-tn:mezz.eth'}
            className='whitespace-nowrap transition-colors hover:text-gray-50'
            target='_blank'
            rel='noopener noreferrer'
          >
            Snapshot Voting
          </a>
          <a
            href={DOCS_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='whitespace-nowrap transition-colors hover:text-gray-50'
          >
            Docs
          </a>
          <a href={commonRoutes.TERM_OF_SERVICE} className='whitespace-nowrap transition-colors hover:text-gray-50'>
            Terms of Service
          </a>
          <a href={commonRoutes.PRIVACY_POLICY} className='whitespace-nowrap transition-colors hover:text-gray-50'>
            Privacy Policy
          </a>
          <a
            href={externalRoutes.TWITTER}
            target='_blank'
            rel='noopener noreferrer'
            className='whitespace-nowrap transition-colors hover:text-gray-50'
          >
            X (Twitter)
          </a>
          <a
            href={externalRoutes.TELEGRAM}
            target='_blank'
            rel='noopener noreferrer'
            className='whitespace-nowrap transition-colors hover:text-gray-50'
          >
            Telegram
          </a>
          <a
            href={externalRoutes.DISCORD}
            target='_blank'
            rel='noopener noreferrer'
            className='whitespace-nowrap transition-colors hover:text-gray-50'
          >
            Discord
          </a>
        </nav>
      </div>

      <div className='bg-decoration-stroke border-decoration-stroke hidden w-6 border-l xl:block' />
    </footer>
  );
};
